export default __webpack_public_path__ + "static/media/success.baa02ac1.gif";